import { render } from "./AppTextBtn.vue?vue&type=template&id=2fd81404&scoped=true"
import script from "./AppTextBtn.vue?vue&type=script&lang=js"
export * from "./AppTextBtn.vue?vue&type=script&lang=js"

import "./AppTextBtn.vue?vue&type=style&index=0&id=2fd81404&lang=scss&scoped=true"
import "./AppTextBtn.vue?vue&type=style&index=1&id=2fd81404&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd81404"]])

export default __exports__